import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Copy, Check, Gift, MessageCircle } from "lucide-react";

export default function DoctorReferralTab() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/doctor/referral").then(r => setData(r.data)); }, []);
  if (!data) return <p className="text-slate-500 text-sm">Cargando…</p>;
  if (!data.code) {
    return <Card><CardContent className="p-5">
      <p className="text-sm text-slate-600">Tu código de referido estará disponible una vez que tu cuenta sea aprobada.</p>
    </CardContent></Card>;
  }

  const link = data.share_url;
  const wa = `https://wa.me/?text=${encodeURIComponent(`Pruebe Agendik 30 días gratis con mi código ${data.code}: ${link}`)}`;
  const copy = () => { navigator.clipboard.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 1500); toast.success("Copiado"); };

  return (
    <div className="space-y-5">
      <Card><CardContent className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <Gift size={18} className="text-blue-600"/>
          <h3 className="font-semibold text-slate-900">Programa de referidos</h3>
        </div>
        <p className="text-sm text-slate-600 mb-4">
          Invita colegas y obtén <strong>$7 USD de descuento/mes por colega confirmado</strong> (máximo $49 = suscripción gratis).
        </p>
        <div className="text-3xl font-bold font-mono text-blue-700">{data.code}</div>
        <div className="flex gap-2 mt-3">
          <Input readOnly value={link} data-testid="doctor-referral-link" className="font-mono text-xs"/>
          <Button data-testid="doctor-referral-copy" size="icon" variant="outline" onClick={copy}>
            {copied ? <Check size={14} className="text-emerald-600"/> : <Copy size={14}/>}
          </Button>
          <Button data-testid="doctor-referral-wa" size="sm" onClick={() => window.open(wa, "_blank")}
                  className="bg-emerald-600 hover:bg-emerald-700 whitespace-nowrap">
            <MessageCircle size={14} className="mr-1"/> WhatsApp
          </Button>
        </div>
        <div className="flex gap-2 mt-3">
          <Button data-testid="doctor-flyer-btn" size="sm" onClick={async () => {
            try {
              const r = await api.get("/doctor/flyer", { responseType: "blob" });
              const u = URL.createObjectURL(r.data);
              const a = document.createElement("a"); a.href = u;
              a.download = `agendik-flyer-${data.code}.pdf`; a.click(); URL.revokeObjectURL(u);
            } catch { toast.error("Error"); }
          }} className="bg-blue-600 hover:bg-blue-700">
            Descargar mi flyer (PDF A5)
          </Button>
          <Button data-testid="doctor-story-btn" size="sm" onClick={async () => {
            try {
              const r = await api.get("/doctor/flyer-story", { responseType: "blob" });
              const u = URL.createObjectURL(r.data);
              const a = document.createElement("a"); a.href = u;
              a.download = `agendik-story-${data.code}.png`; a.click(); URL.revokeObjectURL(u);
            } catch { toast.error("Error"); }
          }} className="bg-pink-600 hover:bg-pink-700">
            Instagram Story (1080×1920)
          </Button>
        </div>
      </CardContent></Card>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Card><CardContent className="p-5">
          <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Colegas confirmados</div>
          <div className="text-3xl font-bold text-slate-900 mt-1">{data.confirmed_count}</div>
        </CardContent></Card>
        <Card><CardContent className="p-5">
          <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Descuento actual</div>
          <div className="text-3xl font-bold text-emerald-600 mt-1">-${data.current_discount_usd}/mes</div>
        </CardContent></Card>
        <Card><CardContent className="p-5">
          <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Próxima factura</div>
          <div className="text-3xl font-bold text-slate-900 mt-1">${data.next_invoice_amount_usd}</div>
        </CardContent></Card>
      </div>

      {data.confirmed_count >= 7 && (
        <Card className="border-emerald-300 bg-emerald-50"><CardContent className="p-5 text-center">
          <div className="text-lg font-bold text-emerald-800">¡Su suscripción es gratuita!</div>
          <p className="text-sm text-emerald-700 mt-1">Ha alcanzado 7 colegas confirmados. Descuento máximo aplicado.</p>
        </CardContent></Card>
      )}
    </div>
  );
}
